// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"2af4ea91","82":"4bfbc524","148":"1b2868cc","175":"4e9d4273","313":"0a7493f9","351":"33c9d19c","453":"0b781a21","677":"ac760f34","726":"4a342d6c","872":"d76dd0ba","898":"0d9ebeac"}[chunkId] + ".chunk.js";
};